import api from '@pray/shared/utils/api';

import type { SmsConfig } from './types';

type GetSmsConfigProps = {
  artistId: string;
};

export async function getSmsConfig({ artistId }: GetSmsConfigProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/sms-config`;

  const response = await api.executeGetRequest<{ data: SmsConfig }>(url);

  return response.data;
}
